import axios from 'axios';

const NO_STRIPE_ID_MSG = 'Client is not associated with a stripe account';

export const updateStripeRecipient = async (
  email: string,
  userId?: string,
  orgId?: string,
) => {
  try {
    const { data } = await axios.post(`/billing/update_recipient`, {
      params: {
        email,
        userId,
        orgId,
      },
    });

    // Success case
    const successMessage = 'Recipient updated successfully.';
    return { updatedEmail: data.email, successMessage };
  } catch (error) {
    // Error case
    const networkError = error.response?.data?.error;
    const graphQLErrors = networkError?.result?.[0]?.errors;

    if (
      graphQLErrors?.some((err: { message: string | string[] }) =>
        err.message.includes(NO_STRIPE_ID_MSG),
      )
    ) {
      const errorMessage =
        'Please add a payment method before managing recipient.';
      throw new Error(errorMessage);
    }

    throw error;
  }
};
